import { useDispatch, useSelector } from 'react-redux'
import { resetInputAmountAndRiders, setSelectedAmountOfLoansBox } from '../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice'
import { selectIsBasicPlansComplete, selectIsProductTypeComplete } from '../../../../../helper/proposal/proposal-is-complete-form-helper'
import { Checked } from '../../../../../assets/icon/svg'
import { resetLevelRanking } from '../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice'
import { resetUniformCoverage } from '../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice'
import { resetSalaryRank } from '../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice'
import { resetSelectedRiders } from '../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice'
import { useLoanAmountTypeQuery } from '../../../../../api/gms/group-category/group-category-api'
import LoadingCategory from '../../../../ui/loading-category'
import ErrorFetch from '../../../../ui/error-fetch-category'
import { resetCoverageType } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice'
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state'
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'

export default function ClientInputAmountLoans() {

    const { data: loanAmount , isError: isErrorLoanAmount, isLoading: isLoadingLoanAmount } = useLoanAmountTypeQuery();
    const isErrorLoading = isErrorLoanAmount || isLoadingLoanAmount
    
    const dispatch = useDispatch()
    const { amountOfLoans, } = useProposalTypeData()
    const isBasicPlansComplete = useSelector(selectIsBasicPlansComplete);
    const isProductTypeComplete = useSelector(selectIsProductTypeComplete);
    const isDisableCheckbox = isProductTypeComplete && isBasicPlansComplete;

    const mappedOptions: SubTypeOption[] = loanAmount?.map(item => ({
        id: item.id,
        name: item.name
    })) || [];

    const handleChangeAmountOfLoans = (option: SubTypeOption) => {
        dispatch(setSelectedAmountOfLoansBox(option));
        dispatch(resetCoverageType())
        dispatch(resetLevelRanking())
        dispatch(resetUniformCoverage())
        dispatch(resetSalaryRank())
        dispatch(resetSelectedRiders())
        dispatch(resetInputAmountAndRiders())
    };
    
    return (
        <div className="space-y-2">
            <div className={`grid gap-2 ${ isErrorLoading ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' }`} >
                {isLoadingLoanAmount ? (
                    <LoadingCategory />
                ) : isErrorLoanAmount ? (
                    <ErrorFetch />
                ) : (
                    mappedOptions.map((option) => {
                        const isSelected = amountOfLoans?.id === option.id;
                        return (
                            <label
                                key={option.id}
                                className={`flex items-center gap-2 rounded border px-3 py-2 transition-all duration-200  
                                    ${!isDisableCheckbox ? 'cursor-not-allowed border-gray-200 bg-gray-100 opacity-50'
                                        : isSelected ? 'cursor-pointer border-[#186cb2]/30 bg-[#186cb2]/10 shadow-sm'
                                            : 'cursor-pointer border-gray-200 bg-white hover:border-[#186cb2] hover:bg-gray-50'
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    name="amountOfLoans"
                                    disabled={!isDisableCheckbox}
                                    checked={isSelected}
                                    onChange={() => handleChangeAmountOfLoans(option) }
                                    className="hidden"
                                />
                                {/* CUSTOM RADIO / CHECK */}
                                <div
                                    className={`flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border transition-all duration-200 ${
                                        isSelected
                                            ? 'border-[#186cb2] bg-[#186cb2]'
                                            : 'border-gray-400 bg-white'
                                    }`}
                                >
                                    {isSelected && (
                                        <Checked />
                                    )}
                                </div>
                                {/* LABEL */}
                                <span
                                    className={`flex-1 whitespace-normal break-words text-xs leading-5 ${
                                        isSelected ? 'font-medium text-[#186cb2]' : 'text-gray-700'
                                    }`}
                                >
                                    {option.name}
                                </span>
                            </label>
                        );
                    })
                )}
            </div>
        </div>
    );
}
